export default __webpack_public_path__ + "navigation-examples-embedded-navigation-thumbnail-960-43f3af58b32f08a99e0812553ca22dab.png";